import styled from '@emotion/styled';
import React from 'react';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { Box, Button, Card } from '~Styles';

const Dimmer = styled.div`
  z-index: 1;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--colorBlueGray200);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
`;

export default function OutOfStockDimmer() {
  const match = useRouteMatch<{ id: string }>();

  return (
    <Dimmer>
      <Card padding="xl" backgroundColor="colorBlueGray1200" color="colorBlueGray200">
        <Box marginBottom="large">
          This category has been marked as <b>Out of stock</b>
        </Box>

        <NavLink
          to={`/venue/${match.params.id}/inventory/categories`}
          style={{ textDecoration: 'none' }}>
          <Button fluid>Go to Inventory manager</Button>
        </NavLink>
      </Card>
    </Dimmer>
  );
}
